var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ul", { attrs: { id: "list-tasks" } }, [
    _c("li", [
      _c("div", { attrs: { id: "oblea" } }, [
        _c("div", { attrs: { id: "s1" } }, [
          _c("img", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.imagenProducto == null,
                expression: "imagenProducto == null"
              }
            ],
            staticStyle: { width: "40px", height: "40px" },
            attrs: { id: "imagenPlaceholder", src: "/dist/progress-item.gif" }
          }),
          _vm._v(" "),
          _c("img", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.imagenProducto != null,
                expression: "imagenProducto != null"
              }
            ],
            staticStyle: { width: "50px" },
            attrs: { id: "imagenProducto", src: _vm.imagenProducto }
          })
        ]),
        _vm._v(" "),
        _c("div", { attrs: { id: "s2" } }, [
          _c("p", { attrs: { id: "titulo" } }, [
            _vm._v(_vm._s(_vm.item.Nombre))
          ]),
          _vm._v(" "),
          _c("p", { attrs: { id: "descrip" } }, [
            _vm._v(_vm._s(_vm.item.Observacion))
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "label" }, [_vm._v("Pedido Mínimo:")]),
          _vm._v(" "),
          _c("span", { staticClass: "value" }, [
            _vm._v(_vm._s(_vm.getPedidoMinimo))
          ]),
          _vm._v(" "),
          _c("span", { attrs: { id: "label-subtotal" } }, [
            _vm._v("Pedido Máximo:")
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "value" }, [
            _vm._v(_vm._s(_vm.getPedidoMaximo))
          ])
        ]),
        _vm._v(" "),
        _c("div", { attrs: { id: "s3" } })
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-78ad0a22", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78ad0a22","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/descuentos/itemDescuento.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-78ad0a22","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/descuentos/itemDescuento.vue
// module chunks = 0